module.exports = __webpack_public_path__ + "img/harvest_1.2730a364.png";